/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useLayoutEffect } from 'react'
import {
  AuthContainer,
  AuthFormBg,
  AuthFormContainer,
  AuthFormHeader,
  AuthFormSubtitle,
  AuthFormTitle,
} from '../style'

import { LogoContainer } from '../signup/components/success/style'
import { RootState, useAppDispatch, useAppSelector } from 'store/store'
import { LoginForm } from 'pages/auth/login/components/login-form/LoginForm'
import { ForgotPassword } from 'pages/auth/login/components/forgot-password/ForgotPassword'
import { SuccessPage } from 'pages/auth/signup/components/success/SuccessPage'
import { ResetPassword } from 'pages/auth/login/components/reset-password/ResetPassword'
import { FormTypes } from 'types/enums/EFormTypes'
import { ESignupFormSteps } from 'types/enums/ESignupFormSteps'
import { useSelector } from 'react-redux'
import { EDirection } from 'types/enums/ELanguage'
import { Loader } from 'shared/components/loader/loader'
import { ResetPasswordSuccess } from './components/reset-password-success/ResetPasswordSuccess'
import { Logo } from 'styles/generics'
import { MarketingMessage } from './components/marketing-message/MarketingMessage'
import { windowOpenerPostMessage } from 'shared/helpers/windowOpenerPostMessage'
import { setForm } from 'store/reducers/layoutReducer'
import { getToken } from 'services/AuthService'
import HamburgerMenu from 'shared/components/hamburger-menu/HamburgerMenu'

export type AuthProps = {
  formType: FormTypes | null
  formStep: ESignupFormSteps | null
  direction: EDirection
}

export const Login: React.FC = () => {
  const user = useAppSelector((state) => state.user)
  const { isAuthenticated } = user
  const formType = useSelector((state: RootState) => state.layout.formType)
  const formStep = useSelector((state: RootState) => state.layout.formStep)
  const direction = useSelector(
    (state: RootState) => state.layout.language.direction,
  )
  const isLoading = useSelector((state: RootState) => state.layout.isLoading)

  const authFormTexts = useSelector(
    (state: RootState) => state.layout.authFormTexts,
  )
  const dispatch = useAppDispatch()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [formType])

  useEffect(() => {
    if (isAuthenticated) {
      if (
        !user.personalDetails?.seenMarketingMessage &&
        !user.newsletter &&
        formType !== FormTypes.LAST
      ) {
        dispatch(setForm({ formType: FormTypes.MARKETING_MESSAGE_PAGE }))
      } else {
        if (user.fanzaRedirectUrl) {
          window.location.href = user.fanzaRedirectUrl
        } else {
          const authData = {
            cognitoToken: getToken(),
            firstName: user.personalDetails?.firstName,
            lastName: user.personalDetails?.lastName,
            email: user.email,
            phoneNum: user.personalDetails?.phoneNum,
          }

          windowOpenerPostMessage(authData)
          dispatch(setForm({ formType: FormTypes.SUCCESS_PAGE }))
        }
      }
    }
  }, [
    isAuthenticated,
    user.fanzaRedirectUrl,
    user.newsletter,
    user.personalDetails?.seenMarketingMessage,
  ])

  const renderForm = () => {
    switch (formType) {
      case FormTypes.LOGIN_FORM:
        return <LoginForm />
      case FormTypes.FORGOT_PASSWORD:
        return <ForgotPassword />
      case FormTypes.RESET_PASSWORD:
        return <ResetPassword />
      case FormTypes.RESET_PASSWORD_SUCCESS:
        return <ResetPasswordSuccess />
      case FormTypes.MARKETING_MESSAGE_PAGE:
        return <MarketingMessage />
      case FormTypes.SUCCESS_PAGE:
        return <SuccessPage />
      default:
        return <LoginForm />
    }
  }

  return (
    <AuthContainer
      formType={FormTypes.LOGIN_FORM}
      formStep={formStep}
      direction={direction}
    >
      <AuthFormContainer direction={direction}>
        <HamburgerMenu />
        <AuthFormBg isLoading={isLoading} formType={FormTypes.LOGIN_FORM}>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          <AuthFormHeader>
            <AuthFormTitle className="bold">
              {authFormTexts.title}
            </AuthFormTitle>
            <AuthFormSubtitle>{authFormTexts.subtitle}</AuthFormSubtitle>
          </AuthFormHeader>
          <Loader isLoading={isLoading} />
          {renderForm()}
        </AuthFormBg>
      </AuthFormContainer>
    </AuthContainer>
  )
}
